import i18n from '../i18n';

export const getFriendlyError = (error, fallback) => {
  const fb = fallback ?? i18n.t('errors.generic');
  const message = error?.response?.data?.message;
  if (!message) return fb;
  if (typeof message === 'string') return message;
  if (Array.isArray(message)) return message[0] || fb;
  return fb;
};
